import { dbPrefix, knowledgeAreaArray } from './Constants'
import rebase from "./config/rebase"

export function getKnowledgeAreasFromMain(kA) {
    let toAdd = []
    if (kA === 'ca-agronomia-grad-ufsc' || kA === 'ca-pg-ag-flo-ufsc') {
        toAdd = ['ca-agronomia-grad-ufsc', 'ca-pg-ag-flo-ufsc']
    } else if (kA === 'ca-florestal-grad-ufsc' || kA === 'ca-pg-ag-flo-ufsc') {
        toAdd = ['ca-florestal-grad-ufsc', 'ca-pg-ag-flo-ufsc']
    } else if (kA === 'ca-med-vet-grad-ufsc' || kA === 'ca-pg-mv-zoo-ufsc') {
        toAdd = ['ca-med-vet-grad-ufsc', 'ca-pg-mv-zoo-ufsc']
    }
    toAdd.push("ca-grad-externas", "ca-pg-externas", "ca-externas-empresas")
    return toAdd;
}

export async function getReportsForKA(kA) {
    let toAdd = []
    let reports = []
    if (kA === 'ca-agronomia-grad-ufsc' || kA === 'ca-pg-ag-flo-ufsc') {
        toAdd = ['ca-agronomia-grad-ufsc', 'ca-pg-ag-flo-ufsc']
    } else if (kA === 'ca-florestal-grad-ufsc' || kA === 'ca-pg-ag-flo-ufsc') {
        toAdd = ['ca-florestal-grad-ufsc', 'ca-pg-ag-flo-ufsc']
    } else if (kA === 'ca-med-vet-grad-ufsc' || kA === 'ca-pg-mv-zoo-ufsc') {
        toAdd = ['ca-med-vet-grad-ufsc', 'ca-pg-mv-zoo-ufsc']
    } else {
        toAdd = knowledgeAreaArray.map(k => k.value)
    }

    for (let k of toAdd) {
        let r = await rebase.fetch(dbPrefix + 'reports/' + k, {
            asArray: true
        })

        reports.push(...r)
    }
    return reports;
}

export async function getReportFromKAAndReviewers(kA, reviewer) {
    return await rebase.fetch(dbPrefix + 'reports/' + kA, {
        asArray: true,
        queries: {
            orderByChild: "reviewer",
            equalTo: reviewer
        }
    })
}

export async function getPaperByKey(pKey) {
    return await rebase.fetch(dbPrefix + 'papers/' + pKey, {
        asArray: false
    })
}

export async function getReportsForPaper(knowledgeArea, pKey) {
    return await rebase.fetch(dbPrefix + 'reports/' + knowledgeArea, {
        asArray: true,
        queries: {
            orderByChild: "paper",
            equalTo: pKey
        }
    })
}

export async function getAllReviewers(kA) {
    return await rebase.fetch(dbPrefix + 'reports/reviewers/' + kA, {
        asArray: true
    })
}

export async function updateReport(data, knowledgeArea, key) {
    await rebase.update(dbPrefix + 'reports/' + knowledgeArea + '/' + key, {
        data
    })
}

export async function createEmptyReports(reviewer, paper) {
    await rebase.push(dbPrefix + 'reports/' + paper.knowledgeArea, {
        data: {
            paper: paper.key,
            reviewer: reviewer,
            status: 'open',
            knowledgeArea: paper.knowledgeArea,
        }
    })
}

export async function getPapersFromAccessCode(accessCode, knowledgeArea) {
    let reports = []
    let knowledgeAreaArray = getKnowledgeAreasFromMain(knowledgeArea)
    for (let kA of knowledgeAreaArray) {
        let dBReports = await getReportFromKAAndReviewers(kA, accessCode);
        reports.push(...dBReports)
    }

    let papers = []
    for (let r of reports) {
        if (r.reviewer === accessCode) {
            let paper = await getPaperByKey(r.paper);
            paper.key = r.paper;
            papers.push(paper);
        }
    }
    return papers;

}

export function countReportsByReviewer(reportsArray, reviewerIds) {
    // Inicializa um objeto para armazenar a contagem de reports por reviewer
    let openReportCount = {};
    let coiReportCount = {};
    let finishedReportCount = {};

    // Inicializa a contagem de reports para cada reviewer com valor zero
    reviewerIds.forEach(id => {
        openReportCount[id] = 0;
        coiReportCount[id] = 0;
        finishedReportCount[id] = 0;
    });

    // Itera sobre os reports no array
    reportsArray.forEach(report => {
        let reviewer = report.reviewer;
        let status = report.status;

        // Verifica se o reviewer está na lista de reviewers

        if (reviewerIds.includes(reviewer) && status === "finished") {
            finishedReportCount[reviewer]++;
        }
        if (reviewerIds.includes(reviewer) && status === "open") {
            openReportCount[reviewer]++;
        }
        if (reviewerIds.includes(reviewer) && status === "coi") {
            coiReportCount[reviewer]++;
        }
    });

    // Converte o objeto reportCount para um array de objetos
    let sortedReportCount = Object.keys(openReportCount).map(reviewer => {
        let reportsArrayReviewer = reportsArray.filter(report => report.reviewer === reviewer);
        return { reviewer: reviewer, openReportCount: openReportCount[reviewer], coiReportCount: coiReportCount[reviewer], finishedReportCount: finishedReportCount[reviewer], reportsArray: reportsArrayReviewer };
    });

    // Ordena o array em ordem decrescente de openReport e finishedReport
    sortedReportCount.sort((a, b) => (a.openReportCount + a.finishedReportCount) - (b.openReportCount + b.finishedReportCount))
    return sortedReportCount;
}